import { connect } from 'react-redux'
import { PopupMessageCard } from '../components'

const mapStateToProps = (state, ownProps) => {
  return ({
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PopupMessageCard)


// WEBPACK FOOTER //
// ./src/Pages/Game/containers/PopupMessageCard.js